import {ButtonProps, Button} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuTrash2} from 'react-icons/lu'

export function DeleteResourceButton({children, ...props}: ButtonProps) {
  const {t} = useTranslate('common')

  return (
    <Button variant="ghost" colorPalette="red" {...props}>
      <LuTrash2 />
      {children || t('delete_permanently')}
    </Button>
  )
}
